import React, { useEffect } from "react";
import "./experience-history.css";
import { fadeIn } from "../../utils/elementUtils";

function ExperienceHistory({ id, header, subHeader, details, start, end, timeDelay = 100 }) {
  useEffect(() => {
    if (!id) return;

    // We only need to fade in the time text, geometry is handled by CSS flex/grid now.
    setTimeout(() => {
      let graphTime = document.querySelector(`#${id}-graph-time`);
      if (graphTime) {
        fadeIn(graphTime, 1000, 1, "block");
      }
    }, timeDelay);
  }, [id, timeDelay]);

  return (
    <section id={id} className="experience-outer">
      {/* Timeline Graphic */}
      <div className="timeline-container">
        <div className="timeline-dot"></div>
        <div className="timeline-line"></div>
      </div>

      {/* Content Card */}
      <div className="experience-card">
        <div className="experience-header-group">
          <div>
            <h3 className="experience-main-heading">{header}</h3>
            {subHeader && <h4 className="experience-sub-heading">{subHeader}</h4>}
          </div>
          {start && end && (
            <div id={`${id}-graph-time`} className="experience-time-badge">
              {start} - {end}
            </div>
          )}
        </div>

        {details && details.length > 0 && (
          <ul className="experience-details-list">
            {details.map((detail, index) => (
              <li key={index} className="experience-detail">{detail}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}

export default ExperienceHistory;
